// Feature Flag Codes as stored in [EFUP].[FEATURE_FLAG].[FEAT_FLG_CD]
//If any of these are tied to a permission with a many to many Has - please update util/FeatureFlagUtility featureFlagPermissions
export const FF_PAY_SRCH_EXPORT = 'PAY_SRCH_EXPORT';
export const FF_DASH_PAYMENT_TILES = 'DASH_PAYMENT_TILES';
export const FF_DASH_PAYMENT_TRENDS = 'DASH_PAYMENT_TRENDS';
export const FF_DASH_VENDOR_TILES = 'DASH_VENDOR_TILES';
export const FF_DASH_EXPIRED_PAYMENTS = 'DASH_EXPIRED_PAYMENTS';
export const FF_DASH_PROGRAM_OVERVIEW = 'DASH_PROGRAM_OVERVIEW';
export const FF_INDIVIDUAL_PAYMENTS = 'INDIVIDUAL_PAYMENTS';
export const FF_MULTI_PARTY_PAYMENTS = 'MULTI_PARTY_PAYMENTS';
export const FF_VENDOR_PAYMENTS = 'VENDOR_PAYMENTS';
export const FF_ALL_PAYMENTS = 'ALL_PAYMENTS';
export const FF_USERS_PAGE = 'USERS_PAGE';
export const FF_ROLES_PAGE = 'ROLES_PAGE';
export const FF_PAY_OVERVIEW_STOP_PAYMENT = 'PAY_OVERVIEW_STOP_PAYMENT';
export const FF_PAY_OVERVIEW_RESEND_EMAIL = 'PAY_OVERVIEW_RESEND_EMAIL';

export const FeatureFlagTypes = [
    FF_PAY_SRCH_EXPORT,
    FF_DASH_PAYMENT_TILES,
    FF_DASH_PAYMENT_TRENDS,
    FF_DASH_VENDOR_TILES,
    FF_DASH_EXPIRED_PAYMENTS,
    FF_DASH_PROGRAM_OVERVIEW,
    FF_INDIVIDUAL_PAYMENTS,
    FF_MULTI_PARTY_PAYMENTS,
    FF_VENDOR_PAYMENTS,
    FF_ALL_PAYMENTS,
    FF_USERS_PAGE,
    FF_ROLES_PAGE,
    FF_PAY_OVERVIEW_STOP_PAYMENT,
    FF_PAY_OVERVIEW_RESEND_EMAIL
]